

// import React from 'react';
// import { Box, FormControl, InputLabel, Select, MenuItem, Typography, CircularProgress } from '@mui/material';
// import { useSelector } from 'react-redux';
// import useFEList from './useFEList';
// import { API_BASE_URL } from '../../../config';

// const FEDropdown = ({ 
//   value, 
//   onSelect, 
//   disabled, 
//   label = 'Financial Establishment (M/s)', 
//   showAddress = true 
// }) => {
//   const role = useSelector((s) => s.auth.role);
//   const { feList, feLoading: feListLoading } = useFEList();
//   const [permissionsLoading, setPermissionsLoading] = React.useState(true);
//   const [allowedFEs, setAllowedFEs] = React.useState([]);

//   // Fetch helper to check permissions
//   const fetchPermission = async (url) => {
//     try {
//       const res = await fetch(url, {
//         headers: {
//           'Content-Type': 'application/json',
//           // attach auth token if needed:
//           // Authorization: `Bearer ${localStorage.getItem('token')}`,
//         },
//       });
//       if (!res.ok) return [];
//       const data = await res.json();
//       return Array.isArray(data) ? data.filter(entry => entry.is_active) : [];
//     } catch {
//       return [];
//     }
//   };

//   React.useEffect(() => {
//     const loadPermissions = async () => {
//       if (!feList.length || feListLoading) {
//         setPermissionsLoading(false);
//         return;
//       }

//       setPermissionsLoading(true);
      
//       let permittedFEs = [];
      
//       // Role-based FE filtering
//       switch (role) {
//         case 'super_staff':
//           const superStaffData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-super-staff/`);
//           permittedFEs = superStaffData.map(item => item.financial_establishment);
//           break;
          
//         case 'shirastedar':
//           const shirastedarData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-shirastedar/`);
//           permittedFEs = shirastedarData.map(item => item.financial_establishment);
//           break;
//         case 'forensic_auditor':
//           const forensicAuditData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-forensic-auditor/`);
//           permittedFEs = forensicAuditData.map(item => item.financial_establishment);
//           break;
          
//         // case 'competent_authority':
//         case 'competent_authority': // if there's a separate CA role
//           const caData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-ca/`);
//           permittedFEs = caData.map(item => item.financial_establishment);
//           break;

        

//           case 'assistant_commissioner': // if there's a separate CA role
//             const acData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-ac/`);
//             permittedFEs = acData.map(item => item.financial_establishment);
//             break;

//            case 'joint_secretary': // if there's a separate CA role
//           const jsData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-js/`);
//           permittedFEs = jsData.map(item => item.financial_establishment);
//           break;

//            case 'legal': // if there's a separate CA role
//           const legalData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-legal/`);
//           permittedFEs = legalData.map(item => item.financial_establishment);
//           break;
//            case 'tahsildar': // if there's a separate CA role
//           const tahsildarData = await fetchPermission(`${API_BASE_URL}/fe-mgmt/fe-tahsildar/`);
//           permittedFEs = tahsildarData.map(item => item.financial_establishment);
//           break;
          
//         default:
//           // Other roles see all FEs
//           permittedFEs = feList.map(fe => fe.id);
//       }
      
//       // Filter feList based on permitted FEs
//       const filteredFEs = feList.filter(fe => 
//         permittedFEs.includes(fe.id)
//       );
      
//       setAllowedFEs(filteredFEs);
//       setPermissionsLoading(false);
//     };

//     loadPermissions();
//   }, [role, feList, feListLoading]);

//   const selected = allowedFEs.find(f => f.id === value || f.name_of_fe === value);
//   const loading = feListLoading || permissionsLoading;

//   return (
//     <Box>
//       <FormControl size="small" fullWidth disabled={disabled || loading}>
//         <InputLabel>{loading ? 'Loading FE...' : label}</InputLabel>
//         <Select
//           value={selected?.id || ''}
//           label={loading ? 'Loading FE...' : label}
//           onChange={e => {
//             const fe = allowedFEs.find(f => f.id === e.target.value);
//             onSelect && onSelect(fe || null);
//           }}
//         >
//           <MenuItem value=""><em>— Select —</em></MenuItem>
//           {allowedFEs.map(fe => (
//             <MenuItem key={fe.id} value={fe.id}>
//               {fe.name_of_fe}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
      
//       {showAddress && selected?.address && !loading && (
//         <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5, display: 'block', mt: 0.25 }}>
//           Address: {selected.address}
//         </Typography>
//       )}
      
//       {loading && (
//         <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
//           <CircularProgress size={16} />
//           <Typography variant="caption" color="text.secondary">
//             Loading permissions...
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default FEDropdown;



import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useSelector } from 'react-redux';
import useFEList from './useFEList';
import { API_BASE_URL } from '../../../config';

const FEDropdown = ({
  value,
  onSelect,
  disabled,
  label = 'Financial Establishment (M/s)',
  showAddress = true,
}) => {

  // ONE useSelector call only
const auth = useSelector((state) => state.auth);
const role = auth?.role;

// Extract user UUID from JWT
let userId = null;

try {
  if (auth?.token) {
    const decoded = JSON.parse(
      atob(auth.token.split('.')[1])
    );

    // console.log('JWT DECODED:', decoded);

    userId =
      decoded.user_id ||
      decoded.id ||
      decoded.staff_id ||
      decoded.uuid ||
      null;
  }
} catch (err) {
  console.error('Token decode failed', err);
}

  const { feList, feLoading: feListLoading } = useFEList();

  const [permissionsLoading, setPermissionsLoading] = React.useState(true);
  const [allowedFEs, setAllowedFEs] = React.useState([]);

  const fetchPermission = async (url) => {
    try {
      const res = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!res.ok) return [];

      const data = await res.json();

      return Array.isArray(data)
        ? data.filter((item) => item.is_active)
        : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  React.useEffect(() => {
    const loadPermissions = async () => {
      if (feListLoading) return;

      setPermissionsLoading(true);

      try {
        let permissionData = [];
        let userField = null;

        switch (role) {
          case 'super_staff':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-super-staff/`
            );
            userField = 'super_staff';
            break;

          case 'shirastedar':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-shirastedar/`
            );
            userField = 'shirastedar';
            break;

          case 'forensic_auditor':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-forensic-auditor/`
            );
            userField = 'forensic_auditor';
            break;

          case 'competent_authority':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-ca/`
            );
            userField = 'ca';
            break;

          case 'assistant_commissioner':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-ac/`
            );
            userField = 'ac';
            break;

          case 'joint_secretary':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-js/`
            );
            userField = 'js';
            break;

          case 'legal':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-legal/`
            );
            userField = 'legal';
            break;

          case 'tahsildar':
            permissionData = await fetchPermission(
              `${API_BASE_URL}/fe-mgmt/fe-tahsildar/`
            );
            userField = 'tahsildar';
            break;

          default:
            setAllowedFEs(feList);
            setPermissionsLoading(false);
            return;
        }

        const permittedFEIds = permissionData
          .filter((item) => item[userField] === userId)
          .map((item) => item.financial_establishment);

        const filteredFEs = feList.filter((fe) =>
          permittedFEIds.includes(fe.id)
        );

        setAllowedFEs(filteredFEs);
      } catch (error) {
        console.error(error);
        setAllowedFEs([]);
      } finally {
        setPermissionsLoading(false);
      }
    };

    loadPermissions();
  }, [role, userId, feList, feListLoading]);

  const selected = allowedFEs.find(
    (f) => f.id === value || f.name_of_fe === value
  );

  const loading = feListLoading || permissionsLoading;

  return (
    <Box>
      <FormControl
        size="small"
        fullWidth
        disabled={disabled || loading}
      >
        <InputLabel>
          {loading ? 'Loading FE...' : label}
        </InputLabel>

        <Select
          value={selected?.id || ''}
          label={loading ? 'Loading FE...' : label}
          onChange={(e) => {
            const fe = allowedFEs.find(
              (f) => f.id === e.target.value
            );

            if (onSelect) {
              onSelect(fe || null);
            }
          }}
        >
          <MenuItem value="">
            <em>— Select —</em>
          </MenuItem>

          {allowedFEs.map((fe) => (
            <MenuItem key={fe.id} value={fe.id}>
              {fe.name_of_fe}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showAddress && selected?.address && !loading && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            ml: 0.5,
            display: 'block',
            mt: 0.25,
          }}
        >
          Address: {selected.address}
        </Typography>
      )}

      {loading && (
        <Box
          sx={{
            mt: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <CircularProgress size={16} />
          <Typography
            variant="caption"
            color="text.secondary"
          >
            Loading permissions...
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FEDropdown;